import * as React from 'react';
import styles from './index.less';
import AttrsAndConfigsItem from './AttrsAndConfigsItem';

export interface IAttrsAndConfigsItem {
  key: string;
  name: string;
  description: string;
  value: string;

  configs: {
    item_Deletable: boolean;
    key_Editable: boolean;
    name_Editable: boolean;
    description_Editable: boolean;
    value_Editable:
      | false
      | {
          text?: {
            nullable: boolean;
            minLength: number;
            maxLength: number;
          };
          textArea?: {
            nullable: boolean;
            minLength: number;
            maxLength: number;
          };
          integer?: {
            nullable: boolean;
            min: number;
            max: number;
          };
          decimal?: {
            nullable: boolean;
            minDecimal: number;
            maxDecimal: number;
            precision: number;
          };
          date?: {
            nullable: boolean;
            startDate: string;
            limitDate: string;
          };
          dataTime?: {
            nullable: boolean;
            startDateTime: string;
            limitDateTime: string;
          };
          configText?: {
            nullable: boolean;
            defaultValue: string;
            minLength: number;
            maxLength: number;
          };
          configEnum?: {
            nullable: boolean;
            defaultValue: string;
            options: string[];
          };
        };
  };
}

interface FAttrsAndConfigsProps {
  dateSource: IAttrsAndConfigsItem[];

  onChange?: (
    dateSource: IAttrsAndConfigsItem[],
    changedFields: Array<Omit<keyof IAttrsAndConfigsItem, 'configs'>>,
  ) => void;

  onChangeItem?: (
    oldData: IAttrsAndConfigsItem,
    newData: IAttrsAndConfigsItem,
    index: number,
    changedFields: Array<Omit<keyof IAttrsAndConfigsItem, 'configs'>>,
  ) => void;
  onDeleteItem?: (data: IAttrsAndConfigsItem, index: number) => void;
  disabledKeys: string[];
  disabledNames: string[];

  itemWidth?: string | number;
}

function FAttrsAndConfigs({
  dateSource,
  onChange,
  onChangeItem,
  onDeleteItem,
  disabledKeys,
  disabledNames,
  itemWidth,
}: FAttrsAndConfigsProps) {
  return (
    <div className={styles.container}>
      {dateSource.map((item, index) => {
        return (
          <AttrsAndConfigsItem
            data={item}
            key={item.key}
            itemWidth={itemWidth}
            onChange={(dataOld, dataNew, changedFields) => {
              const newDateSource = [...dateSource];
              newDateSource[index] = dataNew;
              onChange?.(newDateSource, changedFields);
              onChangeItem?.(dataOld, dataNew, index, changedFields);
            }}
            onDelete={() => {
              const newDateSource = [...dateSource];
              newDateSource.splice(index, 1);
              onChange?.(newDateSource, []);
              onDeleteItem?.(item, index);
            }}
            disabledKeys={disabledKeys}
            disabledNames={disabledNames}
          />
        );
      })}
    </div>
  );
}

export default FAttrsAndConfigs;
